export const laws = {
  page_header_title: "Laws A-Z",
  page_header_subtitle: "Browse all laws in alphabetical order",
};
